var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHMenuOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 51,
    viewBox: "0 0 48 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.539307,
    width: 48,
    height: 49.618,
    rx: 24,
    fill: "#00C495"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9704 19.7846L13 12.9438V19.3813L23.9704 25.8873L34.9482 19.3813V12.9438L23.9704 19.7846Z",
    fill: "#0F1936"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9704 31.2291L13 38.0699V31.6324L23.9704 25.1188L34.9482 31.6324V38.0699L23.9704 31.2291Z",
    fill: "#0F1936"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHMenuOpen);
export default __webpack_public_path__ + "static/media/hMenuOpen.7c60854c8344b994d2cf1dd9ba030106.svg";
export { ForwardRef as ReactComponent };